<div class="dialog-box">
    <div class="dialog-box__nav">
        <nw-icon
            class="dialog-box__nav__icon"
            [ngClass]="'dialog-box__nav__icon--' + type"
            [icon]="icon"
        ></nw-icon>
        <button
            nw-icon-button
            type="button"
            class="dialog-box__nav__close-btn"
            (click)="closeBox.emit()"
        >
            <nw-icon icon="xmark"></nw-icon>
        </button>
    </div>
    <div class="dialog-box__header" [ngClass]="'dialog-box__header--' + type">
        <ng-content select="[dialog-box-header]"></ng-content>
    </div>
    <div class="dialog-box__body">
        <ng-content select="[dialog-box-body]"></ng-content>
    </div>

    <ng-content select="[dialog-box-actions]"></ng-content>
</div>
